import { createFileRoute, useNavigate, useRouteContext } from '@tanstack/react-router';
import { Flex } from 'antd';
import { useEffect } from 'react';

import { AgentDeliveriesPanel } from '../../../../../modules/ai-agent/components';
import { useGetAiAgentQuery } from '../../../../../modules/ai-agent/hooks';

const AgentDeliveriesRoute = () => {
  const navigate = useNavigate();
  const { selectedOrganization } = useRouteContext({ from: '/_authenticated/_app' });
  const { agentId } = Route.useParams();
  const organizationId = selectedOrganization.id;

  const { data: agentResponse } = useGetAiAgentQuery(organizationId, agentId);
  const agentData = agentResponse?.data;

  useEffect(() => {
    if (agentData?.state === 'draft') {
      navigate({
        to: '/agents/$agentId',
        params: { agentId },
        replace: true,
      });
    }
  }, [agentData?.state, navigate, agentId]);

  if (!agentData || agentData.state === 'draft') return null;

  return (
    <Flex flex={1} vertical style={{ padding: 24 }}>
      <AgentDeliveriesPanel organizationId={organizationId} agentId={agentId} />
    </Flex>
  );
};

export const Route = createFileRoute('/_authenticated/_app/agents/$agentId/deliveries')({
  component: AgentDeliveriesRoute,
});
